import { useContext } from 'react';
import { HeaderPanelContext } from './header-panel-context';

export function useHeaderPanel() {
    return useContext(HeaderPanelContext);
}
